var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChargeStatus5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 55,
    viewBox: "0 0 53 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.6635 15.345L21.2 33.4675L11.6865 23.6225L7.95 27.5L21.2 41.25L42.4 19.25L38.6635 15.345ZM26.5 0C11.872 0 0 12.32 0 27.5C0 42.68 11.872 55 26.5 55C41.128 55 53 42.68 53 27.5C53 12.32 41.128 0 26.5 0ZM26.5 49.5C14.787 49.5 5.3 39.655 5.3 27.5C5.3 15.345 14.787 5.5 26.5 5.5C38.213 5.5 47.7 15.345 47.7 27.5C47.7 39.655 38.213 49.5 26.5 49.5Z",
    fill: "#FFF28D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargeStatus5);
export default __webpack_public_path__ + "static/media/charge-status5.75f12e705e08cdbad51fbeff521e822c.svg";
export { ForwardRef as ReactComponent };